<template>
	<!-- Grid card layout für die gefundenen Einträge? Kuckst Du hier https://codepen.io/munieru_jp/pen/jpdJNV-->

	<v-container>
		<v-toolbar>
			<v-app-bar-nav-icon @click="nav2Main()">
				<v-icon>mdi-arrow-left-circle-outline</v-icon>
			</v-app-bar-nav-icon>
			<v-toolbar-title>{{ $t("main_title") }} &#x2022; {{ $t("userpair_select_header") }}</v-toolbar-title>
		</v-toolbar>
		<v-card class="mx-auto">
			<v-form ref="userpair_select">
				<v-row>
					<v-col>
						{{ $t('userpair_enter_friend_number') }}
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field v-model.number="friendnumber" :rules="[friendnumber_rules]" ref="friendnumber_input"
							:label="$t('userpair_hint_friend_number')" clearable></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-btn v-if="/^[0-9]{8}/.test(friendnumber)" @click="userpair_query_friend_number()">
							{{ $t('userpair_send_friend_number') }}
						</v-btn>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						{{ $t(this.instruction) }}
					</v-col>
				</v-row>
				<v-col>
					<v-divider></v-divider>
				</v-col>

				<v-row>
					<v-col>
						{{ $t('userpair_own_friend_number') }}
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						{{ this.otp }}
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-btn @click="userpair_request_otp()">
							{{ $t('userpair_generate_friend_number') }}
						</v-btn>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						{{ $t(this.instruction_own) }}
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-btn v-if="otp != 0" @click="userpair_check_friend()">
							{{ $t('userpair_check_friend_number') }}
						</v-btn>
					</v-col>
				</v-row>

				<v-col>
					<v-divider></v-divider>
				</v-col>
				<v-row>
					<v-col>
						<v-text-field v-model="query.searchtext" :label="$t('userpair_select_searchtext')" clearable
							@change="userpair_query_available_publics(0)"></v-text-field>
						<v-btn icon @click="userpair_query_available_publics(0)">
							<v-icon>mdi-magnify</v-icon>
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</v-card>
		<v-list>
			<v-list-item v-for="public_info in public_info_list" :key="public_info.uuid">
				<v-list-item-content>
					<v-list-item-title v-text="public_info.nickname"></v-list-item-title>
					<v-list-item-subtitle v-text="localDate(public_info.timestamp, $t('locale_date_time_format')) +
						' • ' +
						duration(public_info.duration)
						"></v-list-item-subtitle>
					<v-expand-transition>
						<div v-show="public_info.description_show">
							<v-divider></v-divider>

							<v-card-text>{{ public_info.description }}</v-card-text>
						</div>
					</v-expand-transition>
				</v-list-item-content>

				<v-list-item-action>
					<v-btn icon class="mx-4" @click="add_public_friendAdd(public_info.uuid)">
						<v-icon size="24px">mdi-video-plus</v-icon>
					</v-btn>
					<v-btn icon @click="public_info.description_show = !public_info.description_show">
						<v-icon>{{
							public_info.description_show
							? "mdi-chevron-up"
							: "mdi-chevron-down"
						}}</v-icon>
					</v-btn>
				</v-list-item-action>
			</v-list-item>
		</v-list>
		<v-row justify="center">
			<v-dialog dark v-model="waitSearchResults" max-width="300px">
				<!--<v-dialog  max-width="300px"> -->
				<v-card>
					<v-card-title>{{ $t("userpair_wait_for_search") }}</v-card-title>
					<v-divider></v-divider>
					<v-card-text style="height: 75px">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-row>
		<ConfirmDlg ref="confirm" />
	</v-container>
</template>

<script>
import router from "../router";
import messenger from "../messenger";
import ConfirmDlg from "./ConfirmDlg";
import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs-plugin-utc";
dayjs.extend(dayjsPluginUTC, { parseToLocal: true });

export default {
	name: "UserPair",
	components: {
		ConfirmDlg
	},
	data() {
		return {
			uuid: 0,
			otp: "",
			friendnumber: "",
			friendnumber_rules: value => {
				const pattern = /^[0-9]{8}$/
				return pattern.test(value) || this.$t('userpair_friend_number_range')
			},
			instruction: "empty",
			instruction_own: "empty",
			query: {},
			public_info_list: [],
			prev_page: -1,
			query_start_page: 0,
			next_page: -1,
		}
	},
	computed: {
		waitSearchResults: function () {
			return this.public_info_list == null;
		},
	},
	created() {
		try {
			messenger.register("userpair", this.messenger_onMessage, null, null);
			this.uuid = this.$route.params.uuid;
			if (this.$route.params.query) {
				this.query = this.$route.params.query;
				if (this.query.name !== "") {
					this.userpair_query_available_publics(this.query_start_page);
				}
			} else {
				this.query = {
					name: "",
					source_items: [],
					source_values: [],
					provider_items: [],
					provider_values: [],
					category_items: [],
					category_values: [],
					searchtext: "",
				};
			}

		} catch (error) {
			console.log("UserPair exception", error);
			this.nav2Main();
		}
	},
	mounted() {

	},
	methods: {
		nav2Main() {
			router.push({ name: "Home" }); // always goes 'back enough' to Main
		},
		userpair_add_public_friend(uuid) {
			console.log("userpair_add_public_friend", uuid);
			messenger.emit("userpair_add_public_friend", {
				uuid: uuid,
			});
			this.nav2Main();
		},
		userpair_request_otp() {
			console.log("userpair_request_otp",);
			messenger.emit("userpair_request_otp", {});
		},

		messenger_onMessage(type, data) {
			console.log("incoming message to UserPair", type, data);
			if (type == "userpair_request_otp") {
				this.otp = data.otp;
				this.instruction_own = data.errormessage;
			}
			if (type == "userpair_query_friend_number") {
				this.instruction = data.errormessage;
			}

			if (type == "userpair_check_friend") {
				this.instruction = data.errormessage;
				this.confirmPairing(data.nickname, data.other_uuid)
			}
			if (type == "userpair_pair_with_friend") {
				this.instruction_own = data.errormessage;
			}

		},
		userpair_query_available_publics(query_start_page) {
			console.log("userpair_query_available_publics");
			messenger.emit("userpair_query_available_publics", {
				select_source_values: this.query.source_values,
				select_provider_values: this.query.provider_values,
				select_category_values: this.query.category_values,
				select_searchtext: this.query.searchtext,
				query_start_page: query_start_page,
			});
			this.public_info_list = null;
		},
		userpair_query_friend_number() {
			console.log("userpair_query_friend_number");
			messenger.emit("userpair_query_friend_number", {
				friendnumber: this.friendnumber
			});
		},
		userpair_check_friend() {
			console.log("userpair_check_friend");
			messenger.emit("userpair_check_friend", {
				otp: this.otp
			});
		},
		async confirmPairing(nickname, other_uuid) {
			if (
				await this.$refs.confirm.open(
					this.$t("confirm"),
					this.$t("userpair_ok_to_pair") + " " + nickname + "?"
				)
			) {
				this.userpair_pair_with_friend(other_uuid);
			}
		},
		userpair_pair_with_friend(other_uuid) {
			console.log("userpair_pair_with_friend", other_uuid);
			messenger.emit("userpair_pair_with_friend", {
				other_uuid: other_uuid
			});
		},
	},
};
</script>

<style scoped>
h1,
h2 {
	font-weight: normal;
}

ul {
	list-style-type: none;
	padding: 0;
}

li {
	display: inline-block;
	margin: 0 10px;
}

a {
	color: #42b983;
}
</style>
